<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="clarification.title"> </sm-page-header>
  <!-- content -->
  <div class="content">
    <!-- Redacteur tasks table -->
    <div *ngIf="isRedacteur" class="mb-6">
      <sm-data-table-builder [dataTableObject]="redacteurDataTableObject" [datas]="redacteurData || []"
        [loading]="(loadingTasks$ | async) ?? false">
      </sm-data-table-builder>
    </div>
  </div>
</div>